export const FacilityTypes = {
  LONG_TERM_CARE: "Long Term Care",
  HOSPICE: "Hospice",
  HOME_HEALTHCARE: "Home Healthcare",
  PSYCH_HOSPITAL: "Psych Hospital",
  MEDICAL_LAB: "Medical Lab",
  HOSPITAL: "Hospital",
  DENTAL_CLINIC: "Dental Clinic",
  SCHOOL: "School",
  CHILD_CARE_CENTER: "Child Care Center",
} as const;

export const chartingTypes = ["Electronic", "Paper"];

// eslint-disable-next-line unicorn/prevent-abbreviations
export const FacilityStatusObj = {
  UNSIGNED: "unsigned",
  ONBOARDING: "onboarding",
  ENROLLED: "enrolled",
  PROBATION: "probation",
  SUSPENDED: "suspended",
  TERMINATED: "terminated",
  ARCHIVED: "archived",
  PENDING: "pending",
} as const;

export const HcfSelfOnboardingCaseCreationStage = {
  FORM_SUBMITTED: "FORM_SUBMITTED",
  TOS_UNSIGNED: "TOS_UNSIGNED",
  PENDING_SIGN_IN: "PENDING_SIGN_IN",
  PENDING_POSTING_SHIFTS: "PENDING_POSTING_SHIFTS",
  ONBOARDING_COMPLETE: "ONBOARDING_COMPLETE",
};

export const FacilityStatus = Object.values(FacilityStatusObj);

export function isSignedFacilityProfile(facilityProfile: {
  status: (typeof FacilityStatusObj)[keyof typeof FacilityStatusObj];
}): boolean {
  return facilityProfile && facilityProfile.status !== FacilityStatusObj.UNSIGNED;
}

export function isHomeHealthOrHospice(facilityType: string | undefined): boolean {
  return facilityType === FacilityTypes.HOME_HEALTHCARE || facilityType === FacilityTypes.HOSPICE;
}

export function isHealthcareFacility(facilityType: string | undefined): boolean {
  if (!facilityType) {
    return false;
  }

  const healthcareFacilityTypes: Array<string> = [
    FacilityTypes.LONG_TERM_CARE,
    FacilityTypes.HOSPICE,
    FacilityTypes.HOME_HEALTHCARE,
    FacilityTypes.PSYCH_HOSPITAL,
    FacilityTypes.MEDICAL_LAB,
    FacilityTypes.HOSPITAL,
    FacilityTypes.DENTAL_CLINIC,
  ];

  return healthcareFacilityTypes.includes(facilityType);
}
